import { render, staticRenderFns } from "./CreateWorkspaceDialog.vue?vue&type=template&id=37872ea0&scoped=true"
import script from "./CreateWorkspaceDialog.vue?vue&type=script&lang=js"
export * from "./CreateWorkspaceDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateWorkspaceDialog.vue?vue&type=style&index=0&id=37872ea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37872ea0",
  null
  
)

export default component.exports